import React from 'react';
import { notFound } from '../assets/images';
import { Link } from 'react-router-dom';

const NotFoundPage = () => ( 
  <div className='flex items-center justify-center h-screen bg-gray-50'>
    <div className='text-center'>
      <div className='flex justify-center items-center'>
        <img src={notFound} alt="Not Found" className='w-4/5'/>
      </div>
      <div className='flex justify-center items-center'>
        <h1 className='text-2xl mt-20 font-bold'>Page Not Found!</h1>
      </div>
      <div className='flex justify-center mt-4 items-center'>
        <p className='text-lg'>The page you are looking for does not exist.</p>
      </div>
      <div className='flex justify-center mt-4 items-center'>
        <Link to='/' className='bg-blue-700 rounded-md text-white hover:text-white text-base font-fig-semibold p-2 px-6'>Go back to home</Link>
      </div>
    </div>
  </div>
)

export default NotFoundPage;